// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2050":"558de36e","7337":"558de36e","7825":"558de36e","9854":"558de36e"}[chunkId] + ".chunk.css";
};